export const kiemKe = {
  sections: {
    list: { title: 'Kiểm kê' },
    detail: { title: 'Chi tiết phiếu kiểm kê' },
  },
  titles: { add: 'Tạo phiếu kiểm kê' },
  columns: {
    code: 'Mã phiếu',
    chiNhanh: 'Chi nhánh',
    summary: 'Thông tin',
    status: 'Trạng thái',
    time: 'Thời gian',
    ngayCanBang: 'Ngày cân bằng',
    tongSlThucTe: 'SL thực tế',
    tongGiaTriThucTe: 'Tổng thực tế',
    tongChenhLech: 'Tổng chênh lệch',
    slLechTang: 'SL lệch tăng',
    slLechGiam: 'SL lệch giảm',
    note: 'Ghi chú',
    creator: 'Người tạo',
    maPhieuKho: 'Phiếu kho',
  },
  fields: {
    code: 'Mã phiếu',
    chiNhanh: 'Chi nhánh',
    time: 'Thời gian',
    note: 'Ghi chú',
    status: 'Trạng thái',
    creator: 'Người tạo',
    lines: 'Hàng hóa kiểm kê',
    product: 'Hàng hóa',
    productSearch: 'Tìm mã hoặc tên hàng...',
    tonKho: 'Tồn kho',
    soLuongThucTe: 'SL thực tế',
    soLuongLech: 'Chênh lệch',
    tongChenhLech: 'Tổng chênh lệch',
    slLechTang: 'SL lệch tăng',
    slLechGiam: 'SL lệch giảm',
    tongGiaTriThucTe: 'Tổng thực tế',
    ngayCanBang: 'Ngày cân bằng',
    actions: 'Thao tác',
    maHangHoa: 'Mã hàng',
    tenHangHoa: 'Tên hàng',
    donViTinh: 'ĐVT',
    tonKhoHienTai: 'Tồn kho hiện tại',
    thucTe: 'Thực tế',
    slLech: 'SL lệch',
    donGiaVon: 'Đơn giá vốn',
    giaTriLech: 'Giá trị lệch',
    serialImei: 'Serial/IMEI',
    dateSanPham: 'Date sản phẩm',
    lyDoKiemKe: 'Lý do kiểm kê',
    lineNote: 'Ghi chú',
  },
  form: {
    sectionHeader: 'Thông tin phiếu',
    sectionLines: 'Chi tiết hàng kiểm kê',
    maPhieu: 'Mã phiếu',
    maPhieuAuto: 'Tự sinh khi lưu',
    thoiGian: 'Thời gian',
    note: 'Ghi chú',
    maSp: 'Mã hàng',
    tenSp: 'Tên hàng',
    donViTinh: 'ĐVT',
    tonKho: 'Tồn kho hiện tại',
    soLuongThucTe: 'Thực tế',
    soLuongLech: 'SL lệch',
    giaVon: 'Đơn giá vốn',
    giaTriLech: 'Giá trị lệch',
    serialImei: 'Serial/IMEI',
    dateSanPham: 'Date sản phẩm',
    lyDoKiemKe: 'Lý do kiểm kê',
    lineNote: 'Ghi chú',
    productSearch: 'Tìm mã hoặc tên hàng',
    save: 'Lưu',
    lineCount: '{count} mặt hàng',
    tongSoMatHang: 'Số mặt hàng',
    tongSlThucTe: 'Tổng SL thực tế',
    tongChenhLech: 'Tổng SL lệch',
    tongGiaTriLech: 'Tổng giá trị lệch',
  },
  detailTabs: {
    chung: 'Chung',
    generalInfo: 'Thông tin',
    chiTietHang: 'Chi tiết hàng',
  },
  status: {
    phieuTam: 'Phiếu tạm',
    daCanBang: 'Đã cân bằng',
    daHuy: 'Đã hủy',
    daXoa: 'Đã xóa',
  },
  actions: {
    addLine: 'Thêm dòng',
    complete: 'Hoàn thành',
    cancelVoucher: 'Hủy phiếu',
    importExcel: 'Nhập Excel',
    exportExcel: 'Xuất Excel',
    downloadTemplate: 'Tải file mẫu',
    copy: 'Sao chép phiếu',
    dongY: 'Đồng ý',
  },
  formImport: {
    title: 'Nhập hàng kiểm kê từ Excel',
    confirmTitle: 'Xác nhận danh sách hàng kiểm kê',
    errorTitle: 'File Excel không hợp lệ',
    errorHint: 'Vui lòng chọn lại file đúng mẫu.',
    description: 'Chọn file Excel (cột Mã hàng, Số lượng), kiểm tra danh sách rồi xác nhận để ghi vào bảng chi tiết.',
    chooseFile: 'Chọn file',
    confirm: 'Xác nhận danh sách',
    addValidLines: 'Thêm các dòng hợp lệ ({count})',
    previewSummary: 'Khớp {matched}/{total} dòng',
    colStatus: 'Trạng thái',
    statusOk: 'Khớp',
    statusMissing: 'Không tìm thấy',
    noSheet: 'File không có sheet dữ liệu.',
    noData: 'File không có dòng hàng hợp lệ.',
    needMatched: 'Không có dòng nào khớp mã hàng để ghi nhận.',
    allUnmatched: 'Không khớp được mã hàng nào ({total} dòng).',
    someUnmatched: '{count} dòng không tìm thấy mã hàng — đã bỏ qua.',
    applySuccess: 'Đã ghi nhận {success}/{total} dòng vào phiếu.',
  },
  aria: {
    columnPicker: 'Chọn cột hiển thị',
  },
  filter: {
    searchPlaceholder: 'Tìm theo mã phiếu kiểm kê...',
    trangThai: 'Trạng thái',
    nguoiTao: 'Người tạo',
    tuNgay: 'Từ ngày',
    denNgay: 'Đến ngày',
    sortDir: 'Thứ tự',
    asc: 'Tăng dần',
    desc: 'Giảm dần',
  },
  filters: {
    all: 'Tất cả',
    fromDate: 'Từ ngày',
    toDate: 'Đến ngày',
    dateRangePlaceholder: 'Chọn khoảng ngày',
    dateSection: 'Thời gian',
    statusSection: 'Trạng thái',
    peopleSection: 'Người tạo',
    locChung: 'Lọc chung',
    maPhieu: 'Mã phiếu',
    maHangHoa: 'Mã hàng',
    tenHangHoa: 'Tên hàng',
  },
  placeholders: {
    formTitle: 'Tạo / sửa phiếu kiểm kê',
    formBody: 'Nhập thông tin phiếu và danh sách hàng hóa cần kiểm.',
    codeAuto: 'Để trống — hệ thống tự sinh mã KK',
  },
  canBangLo: {
    title: 'Phân bổ lô / IMEI khi cân bằng',
    hint: 'Hàng quản lý theo lô / IMEI có chênh lệch: nhập lô / IMEI cho phần dư (phiếu nhập) và chọn lô / IMEI bị thiếu (phiếu xuất).',
    du: 'Dư {qty} — nhập thêm vào phiếu nhập điều chỉnh',
    thieu: 'Thiếu {qty} — chọn lô / IMEI xuất trong phiếu xuất điều chỉnh',
    maLo: 'Lô / IMEI',
    hanSuDung: 'Hạn sử dụng',
    tonLo: 'Tồn lô',
    soLuong: 'Số lượng',
    themDong: 'Thêm lô / IMEI',
    daPhanBo: 'Đã phân bổ {done} / {total}',
    canMaLo: 'Nhập mã lô / IMEI cho tất cả dòng dư.',
    chuaDu: 'Hàng {ma}: tổng phân bổ phải bằng {total}.',
    vuotTon: 'Hàng {ma}: lô {lo} chỉ còn {ton}.',
    xacNhan: 'Cân bằng',
    huy: 'Đóng',
    loadError: 'Không tải được danh sách lô.',
  },
  messages: {
    loadError: 'Không tải được danh sách phiếu kiểm kê.',
    soKhongDuocAm: 'Số lượng thực tế không được âm.',
    deleteSuccess: 'Đã xóa phiếu kiểm kê.',
    createSuccess: 'Tạo phiếu kiểm kê thành công.',
    updateSuccess: 'Cập nhật phiếu kiểm kê thành công.',
    completeSuccess: 'Hoàn thành phiếu kiểm kê — đã cân bằng tồn kho.',
    cancelSuccess: 'Đã hủy phiếu kiểm kê.',
    importSuccess: 'Nhập Excel thành công.',
    copySuccess: 'Đã sao chép phiếu kiểm kê.',
    noData: 'Không có phiếu kiểm kê.',
    noLines: 'Không có dòng hàng.',
    listSummary: 'Tổng {count} phiếu',
    needMaSp: 'Chọn mã hàng cho dòng đã thêm.',
    needLinesToComplete: 'Phiếu kiểm kê chưa có hàng hóa để cân bằng.',
    needSoLuongThucTe:
      'Phải nhập số lượng thực tế cho mọi hàng trước khi cân bằng ({count} dòng thiếu: {mas}).',
    confirmComplete: 'Hoàn thành phiếu {name}? Tồn kho sẽ được cân bằng.',
    confirmCompleteWarn: 'Thao tác sẽ tạo phiếu nhập/xuất điều chỉnh và cập nhật tồn kho.',
    confirmCompleteHint: 'Chọn lại thời gian phiếu kiểm — dùng làm ngày chứng từ nhập/xuất.',
    confirmCancelVoucher: 'Hủy phiếu {name}? Hành động không thể hoàn tác.',
    confirmCancelDaCanBang:
      'Hủy phiếu {name}? Phiếu nhập/xuất điều chỉnh sẽ bị hủy và tồn kho được hoàn lại.',
  },
}
